import { ElementModels } from '../models';
import { BaseMapper } from './base-mapper';
export class ElementsMapper extends BaseMapper {
    mapTypeElements(elementsRaw) {
        return elementsRaw.map((m) => this.mapTypeElement(m));
    }
    mapTypeElement(rawElement) {
        return rawElement;
    }
    mapElements(elementsRaw) {
        return elementsRaw.map((m) => this.mapElement(m));
    }
    mapElementsWithComponents(elementsRaw) {
        return elementsRaw.map((m) => this.mapElementWithComponents(m));
    }
    mapElementWithComponents(rawElement) {
        return new ElementModels.ContentItemElementWithComponents({
            element: super.mapReference(rawElement.element),
            value: this.mapElementValue(rawElement.value),
            components: this.mapElementComponents(rawElement.components || [])
        });
    }
    mapElement(rawElement) {
        return new ElementModels.ContentItemElement({
            element: super.mapReference(rawElement.element),
            value: this.mapElementValue(rawElement.value),
            mode: rawElement.mode,
            searchableValue: rawElement.searchableValue,
            _raw: rawElement
        });
    }
    mapElementComponents(components) {
        return components.map((m) => new ElementModels.ContentItemElementComponent({
            elements: this.mapElementsWithComponents(m.elements),
            id: m.id,
            type: m.type,
            _raw: m
        }));
    }
    mapElementValue(rawValue) {
        if (Array.isArray(rawValue)) {
            return rawValue.map((m) => super.mapReference(m));
        }
        return rawValue;
    }
}
export const elementsMapper = new ElementsMapper();
//# sourceMappingURL=elements-mapper.js.map